<template>
  <div class="schedule-daily">
    <div
      v-for="hour in hours"
      class="hour-block"
    >
      <div
        v-for="quarter in 4"
        :key="quarter * hour"
        class="quarter-block"
        @click="handleClickQuarter({hour, quarter})"
      >
      </div>
    </div>

    <template v-for="scheduleBl in scheduleBlocks">
      <template
        v-for="(scheduleBlock, index) in scheduleBl.scheduleBlock"
      >
        <DailyScheduleItem
          v-for="schedule in scheduleBlock"
          :key="`${containerIndex}/${schedule.id}/${schedule.dt}`"
          style="position: absolute;"
          :item-height="durationToPxHeight(schedule.end, schedule.dt)"
          :type="type"
          :lesson="schedule"
          :style="presentScheduleItemStyle(schedule, scheduleBl, index)"
          @click="handleClickScheduleItem(schedule)"
        />
      </template>
    </template>
  </div>
</template>

<script>
import dateFns from "date-fns";
import koLocale from "date-fns/locale/ko";
import { getHours } from "@/utils/date-helper.js";
import { distributeBy } from "@/utils/array-helper.js";
import DailyScheduleItem from "./DailyScheduleItem";

const QUATER_PX_HEIGHT = 14;

export default {
	name: "DailyScheduleContainer",
	components: {
		DailyScheduleItem,
	},
	props: ["type", "date", "schedules", "containerIndex"],
	data() {
		return {
			hours: getHours(0, 23),
			scheduleBlocks: [],
		};
	},
	computed: {
		hourHeaders() {
			return this.hours.map(hour =>
				dateFns.format(hour, "A h시", { locale: koLocale })
			);
		},
	},
	watch: {
		schedules: {
			immediate: false,
			handler() {
				this.scheduleBlocks = [];

				this.schedules
					.map(schedule => {
						return {
							...schedule,
							end: dateFns.addMinutes(schedule.dt, schedule.duration),
						};
					})
					.forEach(schedule => {
						let overlapScheduleBlocks = this.scheduleBlocks.filter(
							scheduleBlock => {
								return this.checkRangeOverlap(scheduleBlock, schedule);
							}
						);

            // 스케쥴 블록 단위로 겹치는 것이 있는지 확인
						if (overlapScheduleBlocks.length > 0) {
							let overlapScheduleBlock = overlapScheduleBlocks[0];

							if (dateFns.isAfter(overlapScheduleBlock.dt, schedule.dt)) {
								overlapScheduleBlock.dt = schedule.dt;
							}

							if (dateFns.isBefore(overlapScheduleBlock.end, schedule.end)) {
								overlapScheduleBlock.end = schedule.end;
							}

              // this.checkRangeOverlap 함수를 통해 scheduleBlock의 schedule들이 겹쳐서 그려지지 않도록 배열을 나눔
              // [A, A', B, B', C, C', C''] => [[A, B, C], [A', B', C'], [C'']]가 되도록 나눔
              // [A, B, C]를 첫번째 열에 [A', B', C']를 두번째 열에 [C'']를 세번째 열에 그리면 서로 시간대가 겹쳐도 분리되어서 그려게 하기 위함
							overlapScheduleBlock.schedules.push(schedule);
							overlapScheduleBlock.scheduleBlock = distributeBy(
								overlapScheduleBlock.schedules,
								this.checkRangeOverlap
							);
						} else {
							let newScheduleBlock = {
								dt: schedule.dt,
								end: schedule.end,
								schedules: [schedule],
							};

							newScheduleBlock.scheduleBlock = distributeBy(
								newScheduleBlock.schedules,
								this.checkRangeOverlap
							);
							this.scheduleBlocks.push(newScheduleBlock);
						}
					});
			},
		},
	},
	methods: {
		presentScheduleItemStyle(schedule, scheduleBl, index) {
      let scheduleStart = schedule.dt;
		  let scheduleEnd = schedule.end;

      if(!dateFns.isSameDay(this.date, scheduleStart)) {
        scheduleStart = dateFns.startOfDay(this.date);
      }

		  if(!dateFns.isSameDay(scheduleEnd, this.date)) {
		    scheduleEnd = dateFns.endOfDay(this.date);
      }

			return {
				top: this.durationToPxHeight(scheduleStart, this.hours[0]),
				height: this.durationToPxHeight(scheduleEnd, scheduleStart),
				width: 100 / scheduleBl.scheduleBlock.length + "%",
				left: (100 / scheduleBl.scheduleBlock.length) * index + "%",
			};
		},
		durationToPxHeight(dateLeft, dateRight) {
			return (
				(this.differenceInMinutes(dateLeft, dateRight) / 15) *
					QUATER_PX_HEIGHT +
				"px"
			);
		},
		differenceInMinutes(dateLeft, dateRight) {
      let hours = dateFns.getHours(dateLeft) - dateFns.getHours(dateRight);
			let minutes =
				dateFns.getMinutes(dateLeft) - dateFns.getMinutes(dateRight);

			return hours * 60 + minutes;
		},
		checkRangeOverlap(initialSchedule, compareSchedule) {
			return dateFns.areRangesOverlapping(
				initialSchedule.dt,
				initialSchedule.end,
				compareSchedule.dt,
				compareSchedule.end
			);
		},
		handleClickQuarter({ day, hour, quarter }) {
			if (day) {
				return;
			}

			let dt = dateFns.startOfDay(this.date);
			hour = dateFns.getHours(hour);
			dt = dateFns.setHours(dt, hour);
			dt = dateFns.setMinutes(dt, (quarter - 1) * 15);

			this.$emit("clickTime", dt);
		},
		handleClickScheduleItem(schedule) {
			this.$emit("select", schedule);
		},
	},
};
</script>

<style lang="scss">
.quarter-block {
	height: 14px;
	border-bottom: solid 1px #f2f2f2;
	box-sizing: border-box;
}

.schedule-daily {
	position: relative;
	height: 100%;
	border-right: solid 1px #f2f2f2;

	.quarter-block {
		&:hover {
			background-color: #d3d3d3;
		}
	}

	.hour-block {
		position: relative;
		.quarter-block:last-child {
			border-bottom: solid 2px #f2f2f2;
		}
	}
}

.calendar-schedule {
	position: relative;
	width: calc(100% - 80px);
	display: inline-block;
}
</style>
